// Widget base: gráfica de línea (réplica de "Price Index Por Fecha").
// CAPA 2 de la arquitectura: soporta OVERLAYS componibles declarados en config.
// Aquí los overlays se implementan como datasets de referencia (sin dependencias
// extra). Un overlay nuevo = un caso más en `buildOverlayDatasets`, archivo chico
// y aislado → fácil de extender con Claude Code.
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  Title, Tooltip, Legend, Filler,
} from 'chart.js';
import { formatValue } from '../format';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

function buildOverlayDatasets(overlays, labels, theme) {
  if (!overlays || !overlays.length) return [];
  return overlays.map((ov) => {
    if (ov.type === 'zeroLine') {
      return {
        label: 'Referencia 0%',
        data: labels.map(() => 0),
        borderColor: 'rgba(120,120,120,0.55)',
        borderWidth: 1, borderDash: [4, 4], pointRadius: 0, fill: false, tension: 0,
      };
    }
    if (ov.type === 'targetLine') {
      return {
        label: ov.label || `Meta ${ov.value}`,
        data: labels.map(() => ov.value),
        borderColor: theme.accent,
        borderWidth: 1.5, borderDash: [6, 3], pointRadius: 0, fill: false, tension: 0,
      };
    }
    return null;
  }).filter(Boolean);
}

export default function PriceLineChart({ block, data, theme }) {
  const rows = data?.[block.source] || [];
  const labels = rows.map((r) => r[block.x]);
  const values = rows.map((r) => r[block.y]);

  const mainDataset = {
    label: block.title,
    data: values,
    borderColor: theme.primary,
    backgroundColor: 'rgba(14, 92, 132, 0.08)',
    borderWidth: 2,
    pointBackgroundColor: theme.primary,
    pointRadius: 3, pointHoverRadius: 6,
    tension: 0.25, fill: true,
  };

  const datasets = [mainDataset, ...buildOverlayDatasets(block.overlays, labels, theme)];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: (block.overlays && block.overlays.length > 0), position: 'bottom', labels: { boxWidth: 18, font: { size: 11 } } },
      tooltip: {
        callbacks: { label: (ctx) => `${ctx.dataset.label}: ${formatValue(ctx.raw, block.format)}` },
      },
    },
    scales: {
      y: {
        ticks: { callback: (v) => formatValue(v, block.format), font: { size: 11 }, color: '#6b7280' },
        grid: { color: '#eef2f5' },
      },
      x: { ticks: { font: { size: 10 }, color: '#6b7280', maxRotation: 0, autoSkip: true }, grid: { display: false } },
    },
  };

  return (
    <div className="vz-card">
      <div className="vz-card-title" style={{ background: theme.primary }}>{block.title}</div>
      <div className="vz-chart-body">
        {rows.length === 0
          ? <div className="vz-empty">Sin datos para los filtros seleccionados</div>
          : <Line data={{ labels, datasets }} options={options} />}
      </div>
    </div>
  );
}
